
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/set-up-meal-train",
      function () {
        return require("private-next-pages/set-up-meal-train.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/set-up-meal-train"])
      });
    }
  